import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatNaira } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-12 py-16" data-testid="profile-page">
      <p className="label-eyebrow mb-3">Hello</p>
      <h1 className="font-serif text-5xl tracking-tighter mb-2" data-testid="profile-name">{user.full_name}</h1>
      <p className="text-[#6A747D]">{user.email} {user.role === "admin" && <span className="ml-2 bg-[#FED700] text-[#333E48] px-2 py-1 text-xs uppercase tracking-wider">Admin</span>}</p>

      <button onClick={logout} className="btn-outline mt-6" data-testid="profile-logout-btn">Sign Out</button>

      <h2 className="font-serif text-3xl mt-16 mb-8 tracking-tight">Your orders</h2>
      {orders.length === 0 ? (
        <p className="text-[#6A747D]">No orders yet. <Link to="/shop" className="underline">Start shopping →</Link></p>
      ) : (
        <div className="space-y-4" data-testid="profile-orders-list">
          {orders.map((o) => (
            <Link key={o.id} to={`/receipt/${o.id}`} className="block border border-[#E8E2D9] p-6 hover:border-[#333E48] transition-colors" data-testid={`profile-order-${o.id}`}>
              <div className="flex justify-between flex-wrap gap-3">
                <div>
                  <p className="font-medium">{o.id}</p>
                  <p className="text-sm text-[#6A747D]">{new Date(o.created_at).toLocaleString("en-NG")} · {o.items.length} item(s)</p>
                </div>
                <div className="text-right">
                  <p className="font-serif text-xl">{formatNaira(o.total)}</p>
                  <p className="text-xs uppercase tracking-wider text-[#6A747D]">{o.status}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
